import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AuthenticationService } from './authentication.service';

export const isLoggedInGuard: CanActivateFn = () => inject(AuthenticationService).isLoggedIn();
